<template>
  <header class="header" :class="{ 'header-scrolled': isScrolled || isHeaderHovered }" @mouseenter="handleHeaderEnter" @mouseleave="handleHeaderLeave">
    <div class="header-container">
      <div class="logo">
        <img :src="logoSrc" alt="杭州坤时">
      </div>
      <nav class="nav" v-if="!isMobile">
        <ul>
          <li><router-link to="/" :class="{ active: currentSection === 'home' }">{{ $t('nav.home') }}</router-link></li>
          <li class="dropdown" @mouseenter="handleDropdownEnter('about')" @mouseleave="handleDropdownLeave('about')">
            <router-link to="/about" :class="{ active: currentSection === 'about' }">{{ $t('nav.about') }}</router-link>
            <div class="dropdown-menu" :class="{ 'show': activeDropdown === 'about' }">
              <a href="#" class="drawer-sub-item" @click.prevent="navigateToAboutSection('profile')">{{ $t('about.profile.title') }}</a>
              <a href="#" class="drawer-sub-item" @click.prevent="navigateToAboutSection('culture')">{{ $t('about.culture.title') }}</a>
              <a href="#" class="drawer-sub-item" @click.prevent="navigateToAboutSection('history')">{{ $t('about.history.title') }}</a>
              <a href="#" class="drawer-sub-item" @click.prevent="navigateToAboutSection('honors')">{{ $t('about.honors.title') }}</a>
              <a href="#" class="drawer-sub-item" @click.prevent="navigateToAboutSection('partners')">{{ $t('about.partners.title') }}</a>
            </div>
          </li>
          <li class="dropdown" @mouseenter="handleDropdownEnter('solutions')" @mouseleave="handleDropdownLeave('solutions')">
            <router-link to="/solutions" :class="{ active: currentSection === 'solutions' }">{{ $t('nav.solution') }}</router-link>
            <div class="dropdown-menu" :class="{ 'show': activeDropdown === 'solutions' }">
              <a href="#" @click.prevent="scrollToSolutionSection('unmanned')">{{ $t('solution.unmanned.title') }}</a>
              <a href="#" @click.prevent="scrollToSolutionSection('fuel')">{{ $t('solution.fuel.title') }}</a>
              <a href="#" @click.prevent="scrollToSolutionSection('unloading')">{{ $t('solution.unloading.title') }}</a>
              <a href="#" @click.prevent="scrollToSolutionSection('inspection')">{{ $t('solution.inspection.title') }}</a>
              <a href="#" @click.prevent="scrollToSolutionSection('coreTech')">{{ $t('solution.coreTech.title') }}</a>
            </div>
          </li>
          <li><router-link to="/news">{{ $t('nav.news') }}</router-link></li>
          <li class="dropdown" @mouseenter="handleDropdownEnter('contact')" @mouseleave="handleDropdownLeave('contact')">
            <router-link to="/contact">{{ $t('nav.contact') }}</router-link>
            <div class="dropdown-menu" :class="{ 'show': activeDropdown === 'contact' }">
            </div>
          </li>
        </ul>
      </nav>
      <div class="header-right" v-if="!isMobile">
        <!-- <div class="search-box">
          <input type="text" :placeholder="$t('nav.search')" v-model="searchText" @keyup.enter="handleSearch">
          <i class="el-icon-search" @click="handleSearch"></i>
        </div> -->
        <div class="lang-switch">
          <span :class="{ active: currentLang === 'zh' }" @click="switchLang('zh')">CN</span>
          <span class="divider">|</span>
          <span :class="{ active: currentLang === 'en' }" @click="switchLang('en')">EN</span>
        </div>
      </div>
      <!-- 汉堡按钮 -->
      <div class="menu-toggle" v-if="isMobile" @click="drawerOpen = true">
        <svg width="28" height="28" viewBox="0 0 28 28"><rect y="6" width="28" height="3" rx="1.5" fill="#fff"/><rect y="13" width="28" height="3" rx="1.5" fill="#fff"/><rect y="20" width="28" height="3" rx="1.5" fill="#fff"/></svg>
      </div>
    </div>
    <!-- 全屏抽屉导航 -->
    <transition name="fade">
      <div class="menu-drawer" v-if="drawerOpen">
        <div class="drawer-header">
          <img src="@/assets/logo.png" alt="logo" class="drawer-logo">
          <span class="drawer-close" @click="drawerOpen = false">&times;</span>
        </div>
        <div class="drawer-list">
          <router-link class="drawer-item" to="/" @click.native="drawerOpen = false">{{ $t('nav.home') }}</router-link>
          
          <!-- About with sub-items -->
          <div class="drawer-item-with-sub">
            <div class="drawer-item" @click="toggleSubMenu('about')">
              {{ $t('nav.about') }}
              <span class="sub-arrow" :class="{ 'sub-arrow-open': showSubMenu === 'about' }">▼</span>
            </div>
            <div class="drawer-sub-list" v-show="showSubMenu === 'about'">
              <a href="#" class="drawer-sub-item" @click.prevent="navigateToAboutSection('profile')">{{ $t('about.profile.title') }}</a>
              <a href="#" class="drawer-sub-item" @click.prevent="navigateToAboutSection('culture')">{{ $t('about.culture.title') }}</a>
              <a href="#" class="drawer-sub-item" @click.prevent="navigateToAboutSection('history')">{{ $t('about.history.title') }}</a>
              <a href="#" class="drawer-sub-item" @click.prevent="navigateToAboutSection('honors')">{{ $t('about.honors.title') }}</a>
              <a href="#" class="drawer-sub-item" @click.prevent="navigateToAboutSection('partners')">{{ $t('about.partners.title') }}</a>
            </div>
          </div>

          <!-- Solutions with sub-items -->
          <div class="drawer-item-with-sub">
            <div class="drawer-item" @click="toggleSubMenu('solutions')">
              {{ $t('nav.solution') }}
              <span class="sub-arrow" :class="{ 'sub-arrow-open': showSubMenu === 'solutions' }">▼</span>
            </div>
            <div class="drawer-sub-list" v-show="showSubMenu === 'solutions'">
              <a href="#" class="drawer-sub-item" @click.prevent="scrollToSection('unmanned')">{{ $t('solution.unmanned.title') }}</a>
              <a href="#" class="drawer-sub-item" @click.prevent="scrollToSection('fuel')">{{ $t('solution.fuel.title') }}</a>
              <a href="#" class="drawer-sub-item" @click.prevent="scrollToSection('unloading')">{{ $t('solution.unloading.title') }}</a>
              <a href="#" class="drawer-sub-item" @click.prevent="scrollToSection('inspection')">{{ $t('solution.inspection.title') }}</a>
              <a href="#" class="drawer-sub-item" @click.prevent="scrollToSection('coreTech')">{{ $t('solution.coreTech.title') }}</a>
            </div>
          </div>

          <router-link class="drawer-item" to="/news" @click.native="drawerOpen = false">{{ $t('nav.news') }}</router-link>
          <router-link class="drawer-item" to="/contact" @click.native="drawerOpen = false">{{ $t('nav.contact') }}</router-link>
        </div>
        <div class="drawer-lang">
          <span :class="{ active: currentLang === 'zh' }" @click="switchLang('zh')">CN</span>
          <span class="divider">|</span>
          <span :class="{ active: currentLang === 'en' }" @click="switchLang('en')">EN</span>
        </div>
      </div>
    </transition>
  </header>
</template>

<script>
export default {
  name: 'CommonHeader',
  props: {
    isScrolled: {
      type: Boolean,
      default: false
    },
    currentSection: {
      type: String,
      default: 'home'
    }
  },
  data() {
    return {
      activeDropdown: null,
      isHeaderHovered: false,
      searchText: '',
      currentLang: localStorage.getItem('lang') || this.$i18n.locale || 'zh',
      drawerOpen: false,
      isMobile: window.innerWidth <= 1300,
      logoSrc: window.innerWidth < 1300 ? '/logo.png' : require('@/assets/logo.png'),
      showSubMenu: null, // 'about' or 'solutions' or null
    }
  },
  watch: {
    '$i18n.locale'(val) {
      this.currentLang = val;
    }
  },
  created() {
    this.currentLang = localStorage.getItem('lang') || this.$i18n.locale || 'zh';
    window.addEventListener('resize', this.checkMobile);
    window.addEventListener('resize', this.checkLogo);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
    window.removeEventListener('resize', this.checkLogo);
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 1300;
    },
    checkLogo() {
      this.logoSrc = window.innerWidth < 1300 ? '/logo.png' : require('@/assets/logo.png');
    },
    handleDropdownEnter(dropdownName) {
      this.activeDropdown = dropdownName;
    },
    handleDropdownLeave() {
      this.activeDropdown = null;
    },
    handleHeaderEnter() {
      this.isHeaderHovered = true;
    },
    handleHeaderLeave() {
      this.isHeaderHovered = false;
    },
    handleSearch() {
      if (this.searchText.trim()) {
        // 触发搜索事件
        this.$emit('search', this.searchText);
      }
    },
    switchLang(lang) {
      this.currentLang = lang;
      this.$i18n.locale = lang;
      localStorage.setItem('lang', lang);
      this.$emit('lang-change', lang);
    },
    toggleSubMenu(menu) {
      if (this.showSubMenu === menu) {
        this.showSubMenu = null;
      } else {
        this.showSubMenu = menu;
      }
    },
    scrollToSection(section) {
      const currentRoute = this.$route.path;
      if (currentRoute === '/about' || currentRoute === '/solutions') {
        // If already on the page, just scroll to section
        const element = document.getElementById(section);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
          this.drawerOpen = false;
        }
      } else {
        // If not on the page, navigate first then scroll
        const route = currentRoute === '/about' ? '/about' : '/solutions';
        this.$router.push({ path: route, hash: section }).then(() => {
          this.drawerOpen = false;
        });
      }
    },
    scrollToElement(section) {
      const element = document.getElementById(section);
      if (element) {
        // 使用平滑滚动
        element.scrollIntoView({ behavior: 'smooth' });
        // 更新当前部分
        this.$emit('section-change', section);
      }
    },
    scrollToSolutionSection(section) {
      // 如果当前在 /solutions 页面，直接滚动
      if (this.$route.path === '/solutions') {
        // 使用 requestAnimationFrame 确保在下一帧执行滚动
        requestAnimationFrame(() => {
          const element = document.getElementById(section);
          if (element) {
            // 计算目标位置，考虑固定导航栏的高度
            const headerHeight = 90; // 导航栏高度
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = window.pageYOffset + elementPosition - headerHeight;

            // 使用平滑滚动
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });

            // 更新 URL hash
            if (window.location.hash !== `#${section}`) {
              history.replaceState(null, null, `#${section}`);
            }

            // 更新当前部分
            this.$emit('section-change', section);
          }
        });
      } else {
        // 如果不在目标页面，先导航到目标页面
        this.$router.push({
          path: '/solutions',
          hash: section
        }).then(() => {
          // 等待路由和 DOM 更新完成
          this.$nextTick(() => {
            // 再次使用 requestAnimationFrame 确保在下一帧执行滚动
            requestAnimationFrame(() => {
              const element = document.getElementById(section);
              if (element) {
                const headerHeight = 90;
                const elementPosition = element.getBoundingClientRect().top;
                const offsetPosition = window.pageYOffset + elementPosition - headerHeight;

                window.scrollTo({
                  top: offsetPosition,
                  behavior: 'smooth'
                });

                // 更新当前部分
                this.$emit('section-change', section);
              }
            });
          });
        }).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            throw err;
          }
        });
      }
    },
    navigateToAboutSection(section) {
      // 关闭抽屉菜单
      this.drawerOpen = false;
      
      // 如果已经在 about 页面，直接滚动
      if (this.$route.path === '/about') {
        this.$nextTick(() => {
          const element = document.getElementById(section);
          if (element) {
            const headerHeight = 90;
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = window.pageYOffset + elementPosition - headerHeight;
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          }
        });
      } else {
        // 如果不在 about 页面，先导航到 about 页面
        this.$router.push('/about').then(() => {
          // 等待页面加载完成后再滚动
          setTimeout(() => {
            const element = document.getElementById(section);
            if (element) {
              const headerHeight = 90;
              const elementPosition = element.getBoundingClientRect().top;
              const offsetPosition = window.pageYOffset + elementPosition - headerHeight;
              window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
              });
            }
          }, 100); // 给页面一点加载时间
        });
      }
    }
  },
  computed: {
    currentRoute() {
      return this.$route.path;
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  transition: all 0.3s ease;
  background: transparent;

  &.header-scrolled {
    background: #fff;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

    .header-container {
      .logo img {
        filter: none;
      }

      .nav ul li {
        a {
          color: #333;

          &:hover {
            color: #409EFF;
          }

          &.active {
            color: #409EFF;
          }

          &::after {
            background: #409EFF;
          }
        }

        .dropdown-menu {
          background: #fff;
          box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);

          &::before {
            border-bottom-color: #fff;
          }

          a {
            color: #333;

            &:hover {
              background: #f5f7fa;
              color: #409EFF;
            }
          }
        }
      }

      .header-right {
        .search-box {
          input {
            background: #f5f7fa;
            border: 1px solid #e4e7ed;
            color: #333;

            &::placeholder {
              color: #999;
            }
          }

          i {
            color: #909399;
          }
        }

        .lang-switch {
          color: #333;

          span {
            &:hover {
              color: #409EFF;
              background: #f5f7fa;
            }

            &.active {
              color: #409EFF;
              background: #f5f7fa;
            }

            &.divider {
              color: #dcdfe6;
            }
          }
        }
      }
    }
  }

  .header-container {
    max-width: 1800px;
    margin: 0 auto;
    padding: 25px 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media (max-width: 768px) {
      padding: 12px 20px;
    }

    .logo {
      margin-right: 60px;
      img {
        height: 45px;
        filter: brightness(0) invert(1);

        @media (max-width: 768px) {
          height: 32px;
        }
      }
    }

    .nav {
      flex: 1;
      ul {
        display: flex;
        list-style: none;
        margin: 0;
        padding: 0;
        justify-content: space-between;
        width: 100%;

        li {
          margin: 0 15px;
          position: relative;

          a {
            text-decoration: none;
            color: #fff;
            font-size: 18px;
            font-weight: 500;
            position: relative;
            padding: 8px 15px;
            transition: all 0.3s ease;
            letter-spacing: 1px;
            display: block;
            border-radius: 4px;

            &:hover {
              color: #333;
              // background: rgba(255, 255, 255, 0.9);
            }

            &.active {
              color: #fff;
              opacity: 1;
            }

            &::after {
              content: '';
              position: absolute;
              bottom: 0;
              left: 50%;
              width: 0;
              height: 2px;
              background: #fff;
              transition: all 0.3s ease;
              transform: translateX(-50%);
            }

            &:hover::after {
              width: 0;
            }
          }

          &.dropdown {
            &:hover {
              .dropdown-menu {
                opacity: 1;
                visibility: visible;
                transform: translateX(-50%) translateY(0);
              }
            }

            .dropdown-menu {
              position: absolute;
              top: 100%;
              left: 50%;
              transform: translateX(-50%) translateY(10px);
              background: rgba(255, 255, 255, 0.95);
              min-width: 220px;
              padding: 0;
              border-radius: 4px;
              opacity: 0;
              visibility: hidden;
              transition: all 0.3s ease;
              z-index: 1000;
              box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);

              &.show {
                opacity: 1;
                visibility: visible;
                transform: translateX(-50%) translateY(0);
              }

              &::before {
                content: '';
                position: absolute;
                top: -6px;
                left: 50%;
                transform: translateX(-50%);
                border-left: 6px solid transparent;
                border-right: 6px solid transparent;
                border-bottom: 6px solid rgba(255, 255, 255, 0.95);
              }

              a {
                color: #333;
                padding: 12px 25px;
                font-size: 16px;
                display: block;
                text-align: center;
                transition: all 0.3s ease;
                border-bottom: 1px solid rgba(0, 0, 0, 0.05);
                white-space: nowrap;
                text-decoration: none;
                cursor: pointer;

                &:last-child {
                  border-bottom: none;
                }

                &:hover {
                  background: rgba(0, 0, 0, 0.05);
                  color: #409EFF;
                }

                &::after {
                  display: none;
                }
              }
            }
          }
        }
      }
    }

    .header-right {
      margin-left: 60px;
      display: flex;
      align-items: center;
      gap: 30px;

      .search-box {
        position: relative;
        display: flex;
        align-items: center;
        
        input {
          background: rgba(255, 255, 255, 0.1);
          border: 1px solid rgba(255, 255, 255, 0.2);
          border-radius: 20px;
          padding: 8px 40px 8px 20px;
          color: #fff;
          font-size: 16px;
          width: 180px;
          transition: all 0.3s ease;

          &::placeholder {
            color: rgba(255, 255, 255, 0.6);
          }

          &:focus {
            outline: none;
            background: rgba(255, 255, 255, 0.15);
            border-color: rgba(255, 255, 255, 0.3);
            width: 220px;
          }
        }

        i {
          position: absolute;
          right: 15px;
          color: rgba(255, 255, 255, 0.6);
          cursor: pointer;
          font-size: 18px;
          transition: all 0.3s ease;

          &:hover {
            color: #fff;
          }
        }
      }

      .lang-switch {
        color: #fff;
        font-size: 18px;
        font-weight: 500;
        display: flex;
        align-items: center;
        gap: 10px;
        
        span {
          cursor: pointer;
          padding: 5px 8px;
          transition: all 0.3s ease;
          border-radius: 4px;

          &:hover {
            color: #409EFF;
            background: rgba(255, 255, 255, 0.1);
          }

          &.active {
            color: #409EFF;
            background: rgba(255, 255, 255, 0.1);
          }

          &.divider {
            cursor: default;
            padding: 0;
            color: rgba(255, 255, 255, 0.3);
            
            &:hover {
              background: none;
              color: rgba(255, 255, 255, 0.3);
            }
          }
        }
      }
    }
  }

  .menu-toggle {
    display: none;
    position: absolute;
    right: 20px;
    top: 20px;
    width: 40px;
    height: 40px;
    background: #1d2088;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 1200;
    border-radius: 6px;

    @media (max-width: 768px) {
      width: 32px;
      height: 32px;
      right: 16px;
      top: 16px;
    }
  }

  @media (max-width: 1300px) {
    .nav, .header-right {
      display: none !important;
    }
    .menu-toggle {
      display: flex;
    }
  }
}

.menu-drawer {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: #fff;
  z-index: 2000;
  display: flex;
  flex-direction: column;
  animation: fadeIn 0.3s;
  .drawer-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px 32px 0 32px;

    @media (max-width: 768px) {
      padding: 16px 20px 0 20px;
    }

    .drawer-logo { 
      height: 40px; 
      
      @media (max-width: 768px) {
        height: 32px;
      }
    }
    .drawer-close {
      font-size: 40px;
      color: #1d2088;
      cursor: pointer;
      font-weight: bold;

      @media (max-width: 768px) {
        font-size: 32px;
      }
    }
  }
  .drawer-list {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-top: 32px;
    .drawer-item {
      font-size: 22px;
      color: #222;
      padding: 24px 32px;
      border-bottom: 1px solid #f0f0f0;
      text-decoration: none;
      font-weight: 500;
      transition: background 0.2s;
      &:hover {
        background: #f5f7fa;
        color: #1d2088;
      }
    }
  }
  .drawer-lang {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px 0 32px 0;
    font-size: 20px;
    background: #f5f7fa;
    border-top: 1px solid #eee;
    .divider { margin: 0 16px; color: #aaa; font-size: 22px; }
    span {
      cursor: pointer;
      padding: 6px 16px;
      border-radius: 4px;
      transition: background 0.2s, color 0.2s;
      &.active { color: #1d2088; font-weight: bold; background: #e6eaff; }
      &:hover { background: #e6eaff; color: #1d2088; }
    }
  }
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.submenu {
  position: absolute;
  top: 100%;
  left: 0;
  background: #fff;
  min-width: 200px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  border-radius: 8px;
  padding: 10px 0;
  opacity: 0;
  visibility: hidden;
  transform: translateY(10px);
  transition: all 0.3s ease;
  z-index: 1000;

  a {
    display: block;
    padding: 12px 20px;
    color: #333;
    font-size: 14px;
    text-decoration: none;
    transition: all 0.3s ease;
    white-space: nowrap;

    &:hover {
      background: #f5f5f5;
      color: #1d2088;
    }

    &.router-link-active {
      color: #1d2088;
      background: #f5f5f5;
      font-weight: 500;
    }
  }
}

.has-submenu {
  position: relative;

  &:hover .submenu {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }
}

.drawer-item-with-sub {
  .drawer-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
  }

  .sub-arrow {
    font-size: 12px;
    transition: transform 0.3s ease;
    margin-left: 8px;
    
    &.sub-arrow-open {
      transform: rotate(180deg);
    }
  }
}

.drawer-sub-list {
  background: rgba(0, 0, 0, 0.05);
  padding: 8px 0;
  margin: 0 -20px;
  padding-left: 40px;
}

.drawer-sub-item {
  display: block;
  padding: 10px 20px;
  color: #666;
  text-decoration: none;
  font-size: 14px;
  transition: all 0.3s ease;

  &:hover {
    color: #1d2088;
    background: rgba(29, 32, 136, 0.05);
  }
}
</style> 